import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'
import { ILanguage } from 'static/languages'

export interface IRegisterData {
  providerUserToken: string
  preferredCurrency: number
  timezone: number
  visitorId: string
  language?: ILanguage['locale']
  clickId?: string
  offer?: string
  partnerId?: string
  gaClickId?: string
  referral?: string
}

const registerByGoogle = (data: IRegisterData): AxiosPromise =>
  apiFetch(`/socialauth/register/google`, { data, method: `POST` })

export default registerByGoogle
